<template>
  <el-dialog
    :title="openType === 'add' ? '新增资源' : '编辑资源'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    destroy-on-close
    custom-class="customModal" >
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型" prop="type" class="formItemFill">
            <el-select v-model="formValue.type" size="small" placeholder="请选择类型" style="width: 100%">
              <el-option label="接口" :value="'0'"></el-option>
              <el-option label="视图" :value="'1'"></el-option>
              <el-option label="菜单" :value="'2'"></el-option>
            </el-select>
          </el-form-item> 
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="父级菜单" prop="pids" class="formItemFill">
            <el-cascader
              size="small"
              style="width: 100%"
              ref="cascader"
              v-if="formValue.pids && formValue.pids.length"
              v-model="formValue.pids"
              :options="treeData"
              :props="{ checkStrictly: true, children: 'sub', label: 'name', value: 'id' }"
              ></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="权限名称" prop="name" class="formItemFill">
            <el-input v-model="formValue.name" size="small" autocomplete="off"></el-input>
          </el-form-item>
          
        </el-col>
        <el-col :span="12">
        <!-- <el-form-item label="路由路径" prop="route_url" class="formItemFill" v-if="formValue.type == 1 || formValue.type == 2">
          <el-input v-model="formValue.route_url" size="small" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="路径" prop="path" class="formItemFill" v-if="formValue.type == 1">
            <el-input v-model="formValue.path" size="small" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon" class="formItemFill" v-if="formValue.type == 2">
            <el-input v-model="formValue.icon" size="small" autocomplete="off"></el-input>
          </el-form-item>
        <el-form-item label="路由路径" class="formItemFill" required v-if="formValue.type==0">
            <el-form-item prop="CTLmodule"  style="float:left;width:48%">
              <el-select v-model="formValue.CTLmodule" size="small" autocomplete="off" @change="getActmodule">
                <el-option v-for="(item,index) in CTLmodule" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="ACTmodule" style="float:left;width:48%;margin-left:2%;">
              <el-select v-model="formValue.ACTmodule" size="small" autocomplete="off" @change="selectChange">
                <el-option v-for="(item,index) in ACTmodule" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否展示" prop="is_show" class="formItemFill"  v-if="formValue.type == 1 || formValue.type == 2">
            <el-radio-group v-model="formValue.is_show" size="small" style="width: 100%">
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="formValue.type == 1 || formValue.type == 2 ? 12 : 24 ">
          <el-form-item label="顺序" prop="sort" class="formItemFill">
            <el-input v-model="formValue.sort" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">确 定</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { PowerService } from '../../service/power.service';
const CTLmodule = []
const ACTmodule = []
  export default {
    name: 'formAuthorize',
    data() {
      return {
        treeData: [],
        visible: false,
        openType: '',
        CTLmodule,
        ACTmodule,
        formValue: { },
        rules: {
          name: [{ required: true, message: '权限名称不能为空'}],
          route_url: [{ required: true, message: '路由路径不能为空'}],
          type: [{ required: true, message: '请选择类型'}],
          pids: [{ required: true, message: '请选择父级菜单'}],
          sort: [{ required:true, message: '排序值不能为空'}],
          CTLmodule: [{ required:true, message: '路由路径不能为空', trigger: 'change'}]
        }
      }
    },
    async created() {
      const ctl = await PowerService.getCTLmodule();
      this.CTLmodule = ctl
      const data = await PowerService.getPowerMenuList();
      this.treeData = [{
        id: 0,
        name: '根菜单',
        sub: data
      }];
    },
    methods: {
      async open(type, data) {
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit') {
          const result = JSON.parse(JSON.stringify(data));
          delete result.sub;
          result.pids = this.findParents(this.treeData, result.pid);
          this.formValue = result;
         if(this.formValue.type == 0) {
           this.formValue.CTLmodule = this.formValue.route_url.split('/')[0]
           this.formValue.ACTmodule = this.formValue.route_url.split('/')[1] || ''
           const data = await PowerService.getActmodule({module:'api',controller:this.formValue.CTLmodule})
           this.ACTmodule = data
         }
        }
        this.openType = type;
        this.visible = true;
      },
      findParents(treeData, id) {
        if (treeData && treeData.length) {
          for (let i = 0; i < treeData.length; i++) {
            if (treeData[i].id === id) {
              return [ id ];
            }
            const found = this.findParents(treeData[i].sub, id);
            if (found) {
              found.unshift(treeData[i].id);
              return found;
            }
          }
        }
      },
      reset() {
        this.formValue = {
          is_show: 1,
          pids: [0],
        };
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
      },
      async update() {
        const data = await PowerService.getPowerMenuList();
        this.treeData = [{
          id: 0,
          name: '根菜单',
          sub: data
        }];
      },
      async submit() {
        const result = await this.$refs.form.validate();
        if (result) {
          if(this.formValue.type == 0) {
            this.formValue.route_url = this.formValue.CTLmodule + '/' + this.formValue.ACTmodule
          }else {
            delete this.formValue.route_url
          }
          delete this.formValue.CTLmodule
          delete this.formValue.ACTmodule
          this.formValue.pid = this.formValue.pids[this.formValue.pids.length - 1];
          await PowerService.addOrEditResource(this.formValue);
          this.$emit('submitSuccess')
          this.update();
          this.close();
        }
      },
      async getActmodule() {
        this.formValue.ACTmodule = ''
        const data = await PowerService.getActmodule({module:'api',controller:this.formValue.CTLmodule})
        this.ACTmodule = data
      },
      selectChange() {
        this.$forceUpdate()
      },
      close() {
        this.visible = false;
        this.formValue = {};
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>